// LIBRARIES
import styled from "styled-components";
import { TextField } from "@mui/material";

// MISC
import { COLORS, FONTS } from "constants/styleVariables";

export const LabelContainer = styled.p`
  color: ${COLORS.secondaryBlack};
  font-family: ${FONTS.montserrat};
  font-weight: 600;
  font-size: 16px;
  margin-bottom: 7px;
`;
export const DateInputAtomContainer = styled.div`
  display: flex;
  flex-direction: column;
`;
export const TextFieldContainer = styled(TextField)`
  & .MuiOutlinedInput-notchedOutline {
    border-color: ${COLORS.cornflowerBlue};
  }
  & .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
    border-color: ${COLORS.cornflowerBlue};
  }
  & .MuiInputBase-root {
    max-width: 200px;
    @media screen and (min-width: 1401px) {
      min-width: 165px;
    }
    @media screen and (max-width: 1400px) {
      min-width: 150px;
    }
    background-color: ${COLORS.backgroundColor};
    border-radius: 5px;
  }
  & .MuiSvgIcon-root {
    @media screen and (max-width: 1400px) {
      font-size: 20px;
    }
  }
  input::placeholder {
    @media screen and (min-width: 1401px) {
      font-size: 14px;
    }
    @media screen and (max-width: 1400px) {
      font-size: 12px;
    }
    color: ${COLORS.primaryGray};
    font-family: ${FONTS.montserrat};
    opacity: 1;
    font-weight: 600;
  }

  input {
    background-color: ${COLORS.backgroundColor};
    color: ${COLORS.cornflowerBlue};
    @media screen and (min-width: 1401px) {
      font-size: 15px;
      padding: 12px 20px 11px 20px;
    }
    @media screen and (max-width: 1400px) {
      font-size: 12px;
      padding: 13px 20px 12px 20px;
    }
    font-family: ${FONTS.montserrat};
    font-weight: 600;
    font-style: normal;
  }
`;
